const getters = {
  session: state => state.admins.session,
  roles: state => state.admins.roles,
  uid: state => state.admins.uid,
  avatar: state => state.admins.avatar,
  locale: state => state.admins.locale
}

export default getters
